import { Button, Flex } from '@chakra-ui/react';
import _ from 'lodash';
import React from 'react';

import {
  PortfolioChartComponentType,
  selectedChartComponentTypeToFAIconMap,
} from './portfolioChartUtils';
import { colors } from 'packages/common-frontend/colors';
import { Icon } from 'packages/common-frontend/components/icons';

const ChartComponentTypeButton = ({
  chartComponentType,
  onClick,
  currentSelectedChartComponentType,
}: {
  chartComponentType: PortfolioChartComponentType;
  onClick: () => void;
  currentSelectedChartComponentType: PortfolioChartComponentType;
}) => {
  const isCurrentlySelected =
    chartComponentType === currentSelectedChartComponentType;

  const iconForComponentType =
    selectedChartComponentTypeToFAIconMap[chartComponentType];

  return (
    <Button
      height="40px"
      width="44px"
      ml="16px"
      padding="6px 16px"
      onClick={onClick}
      borderWidth="thin"
      borderColor={isCurrentlySelected ? colors.aurora[400] : colors.gray[200]}
    >
      {!!iconForComponentType && <Icon icon={iconForComponentType} />}
      {!iconForComponentType && _.startCase(chartComponentType)}
    </Button>
  );
};

export const PortfolioChartComponentTypeSelectButtons: React.FC<{
  currentSelectedChartComponentType: PortfolioChartComponentType;
  onSelectChartComponentType: (
    chartComponentType: PortfolioChartComponentType,
  ) => void;
}> = ({ currentSelectedChartComponentType, onSelectChartComponentType }) => {
  return (
    <Flex>
      <ChartComponentTypeButton
        key="select-chart-component-type-button-line"
        chartComponentType="line"
        onClick={() => onSelectChartComponentType('line')}
        currentSelectedChartComponentType={currentSelectedChartComponentType}
      />
      <ChartComponentTypeButton
        key="select-chart-component-type-button-bar"
        chartComponentType="bar"
        onClick={() => onSelectChartComponentType('bar')}
        currentSelectedChartComponentType={currentSelectedChartComponentType}
      />
    </Flex>
  );
};
